export default "__VITE_ASSET__DdQGpG1Z__"